import I18N from '@leverege/i18n';
import GeoPointModel from "./GeoPointModel.js";
import GeoPointEditor from "./GeoPointEditor.js";
import HistoryModel from "../../shared/renderers/HistoryModel.js";
import HistoryEditor from "./HistoryEditor.js";
import GeoShapeModel from "./GeoShapeModel.js";
import GeoShapeEditor from "./GeoShapeEditor.js";
import UserPositionModel from "../../shared/renderers/UserPositionModel.js";
import { NearbyAccumulator, NearbyAccumulatorEditor } from "../../shared/renderers/accumulator/index.js";
import { UserPositionEditor } from "./index.js";
import GeoPointRenderer from "./GeoPointRenderer.js";
import GeoShapeRenderer from "./GeoShapeRenderer.js";
const {
  tf
} = I18N.ns('molten.dataViewers.map');
const install = molten => {
  molten.addPlugin('Model', {
    type: GeoPointModel.TYPE,
    model: GeoPointModel
  });
  molten.addPlugin('ModelEditor', {
    type: GeoPointModel.TYPE,
    editor: GeoPointEditor
  });
  molten.addPlugin('MapBoxLayerRenderer', {
    type: GeoPointModel.TYPE,
    layerRenderer: GeoPointRenderer
  });
  molten.addPlugin('Model', {
    type: GeoShapeModel.TYPE,
    model: GeoShapeModel
  });
  molten.addPlugin('ModelEditor', {
    type: GeoShapeModel.TYPE,
    editor: GeoShapeEditor
  });
  molten.addPlugin('MapBoxLayerRenderer', {
    type: GeoShapeModel.TYPE,
    layerRenderer: GeoShapeRenderer
  });
  molten.addPlugin('Model', {
    type: UserPositionModel.TYPE,
    model: UserPositionModel
  });
  molten.addPlugin('ModelEditor', {
    type: UserPositionModel.TYPE,
    editor: UserPositionEditor
  });
  molten.addPlugin('ModelEditor', {
    type: HistoryModel.TYPE,
    editor: HistoryEditor
  });
  molten.addPlugin('Model', {
    type: NearbyAccumulator.TYPE,
    model: NearbyAccumulator
  });
  molten.addPlugin('ModelEditor', {
    type: NearbyAccumulator.TYPE,
    editor: NearbyAccumulatorEditor
  });
  molten.addPlugin('HistoryAccumulator', {
    type: NearbyAccumulator.TYPE,
    accumulator: NearbyAccumulator,
    name: tf('nearby')
  });
};
export default {
  install
};